import React, { useCallback, useState } from 'react';
import '../styles/login.scss';
import '../styles/app.css';
import LanguagePicker from './LanguagePicker';
import Grid from '@material-ui/core/Grid';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { DerbySoftMUItheme } from '../styles/muiTheme';
import '../styles/app.css';
import { LocalPersistence, FeatureFlag, ApiCallsFactory } from '../factories/index';
import Loading from './Loading';
import { useSession } from '../store/sessionContext';
import { useHistory } from 'react-router-dom';
import { getSession } from '../helpers/ping';

const theme = createMuiTheme(DerbySoftMUItheme);

function Login() {
  const [userName] = useState('');
  const [password] = useState('');
  const [stayLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const stayLoggedInfo = new LocalPersistence('stayInfo');
  const { session, setSession } = useSession();
  const history = useHistory();
  // const { startIdleTimer } = useIdleTimer()

  const onSignIn = async () => {
    return getSession();
  };

  const isFlaggedComponent = () => {
    const languagePicker = new FeatureFlag(process.env.REACT_APP_LANGUAGE_PICKER);
    return languagePicker.renderFlaggedComponent({ component: () => <LanguagePicker /> });
  };

  const getUserInfo = useCallback(
    async ({ sessionId, companyId }: { sessionId: string; companyId: string | null }) => {
      // get user info
      const userInfo: any = new ApiCallsFactory('/login/userinfo', sessionId, {}, companyId);
      const userResponse = await userInfo.getDataWithCompanyId();

      const persistedSession = window.sessionStorage.getItem('session');
      // @ts-expect-error
      const thisSession = JSON.parse(persistedSession);

      // update session with userInfo
      setSession({
        ...thisSession,
        ...userResponse,
        supplier: userResponse?.supplier,
        userName: userResponse?.email
      });

      userResponse.email && history.push(`/listing`);
    },
    [history, session, setSession]
  );

  React.useEffect(() => {
    const init = async () => {
      try {
        const authCode = window.sessionStorage.getItem('exchange_code');
        const companyId = window.location.search.split('=')[1] || '';
        if (companyId) {
          window.sessionStorage.setItem('companyId', companyId);
        }
        if (authCode) {
          const token = new ApiCallsFactory(
            `/login/exchange?authCode=${authCode}&redirectURL=${process.env.REACT_APP_SSO_REDIRECT_URI}`
          );

          // @ts-expect-error
          const { sessionId } = await token.getData();

          if (sessionId) {
            const companyId = window.sessionStorage.getItem('companyId');
            // set sessionId into session
            await setSession({
              ...session,
              token: sessionId,
              loggedIn: true
            });

            // get userInfo
            await getUserInfo({ sessionId, companyId });
          }
        } else {
          await onSignIn();
        }
      } catch (error) {
        setError(true);
        return console.error(`Login --> ${error}`);
      }
    };
    init();
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    stayLoggedInfo.updateLocalPersistence({ stay: stayLogged, email: userName, pass: password });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName, password, stayLogged]);

  if (loading) return <Loading type='large-text' text='Sign In...' />;
  return (
    <MuiThemeProvider theme={theme}>
      <section id='loginView'>
        {/* <div className='imageLogin'>
            <img src={welcome} alt='login welcome' />
          </div> */}
        <div className='logincontainer'>
          <Grid container spacing={0} className='containerSpacing lightBlueDS' justify='flex-end'>
            {/* <Grid item xs={2} className='itemGrid'>
            {isFlaggedComponent()}
            </Grid> */}
          </Grid>
          {/* replaced by SSO
              <div className='cardDS'>
                <div className='headerTitleDS'>
                  {lang.translate(language, 'sing_to_continue')}
                </div>

                <div className='containerCardDS'>
                  <ButtonDinamyc
                    message={lang.translate(language, 'sign_in').toUpperCase()}
                    classes='buttonBlueDS'
                    action={onSignIn}
                  /> 
                </div>
              </div> 
            */}
          {!error && (
            <div className='loading-spinner'>
              <Loading type='large-text' text='Loading ...' />
            </div>
          )}
          {error && <div className='loading-spinner'>There was an error when Sign In, Please contact your admin.</div>}
          <div className='loginFooter'>© 2002 - {new Date().getFullYear()} DerbySoft Ltd. All rights reserved.</div>
        </div>
      </section>
    </MuiThemeProvider>
  );
}

export default Login;
